const currentYear = new Date().getFullYear()

export default [
  {
    alias: 'widget.entity_type',
    type: 'boxSelect',
    name:"What type of entity is your business?",
    fields: [
      'entity_type'
    ],
    metadata: {
      columns: 2,
    }
  },

  {
    alias: 'widget.average_monthly_sales',
    type: 'boxSelect',
    name: "On average, how much revenue does your business generate each month?",
    fields: ['average_monthly_sales'],
    options: [
      {label: "$0",         value: "0.00", },
      {label: "$1–4K",      value: "4999.00", range: { min: 0.01, max: 4999 } },
      {label: "$5k–7k",     value: "7999.00", range: { min: 5000, max: 7999 }  },
      {label: "$8K–14k",    value: "14999.00", range: { min: 8000, max: 14999 }  },
      {label: "$15K–19k",   value: "19999.00", range: { min: 15000, max: 19999 }  },
      {label: "$20K–49k",   value: "49999.00", range: { min: 20000, max: 49999 }  },
      {label: "$50K–79k",   value: "79999.00", range: { min: 50000, max: 79999 }  },
      {label: "$80K–199k",  value: "199999.00", range: { min: 80000, max: 199999 }  },
      {label: "$200K+",     value: "200000.00", range: { min: 200000 }  }
    ]
  },

  {
    alias: 'widget.annual_personal_income',
    type: 'boxSelect',
    fields: ['annual_personal_income'],
    options: [
      {label: "Below $30K",      "value": "29999.00",  "range": {min: 0, max: 29999},},
      {label: "$30K - $50K",     "value": "50000.00",  "range": {min: 30000, max: 50000},},
      {label: "$50K - $75K",     "value": "75000.00",  "range": {min: 50001, max: 75000},},
      {label: "$75K - $100K",    "value": "100000.00", "range": {min: 75001, max: 100000},},
      {label: "$100K - $150K",   "value": "150000.00", "range": {min: 100001, max: 150000},},
      {label: "Above $150K",     "value": "150001.00", "range": {min: 150001},}
    ]
  },

  {
    alias: 'widget.annual_profits',
    type: 'boxSelect',
    fields: ['annual_profits'],
    options: [
      {label: "<$24K",   "value": "23999.00",  "range": {min: 0, max: 23999},},
      {label: "$24K+",   "value": "48000.00",  "range": {min: 24000, max: 48000},},
      {label: "$48K+",   "value": "72000.00",  "range": {min: 48001, max: 72000},},
      {label: "$72K+",   "value": "96000.00",  "range": {min: 72001, max: 96000},},
      {label: "$96K+",   "value": "120000.00", "range": {min: 96001, max: 120000},},
      {label: "$120K+",  "value": "180000.00", "range": {min: 120001, max: 180000},},
      {label: "$180K+",  "value": "240000.00", "range": {min: 180001, max: 240000},},
      {label: "$240K+",  "value": "240001.00", "range": {min: 240001}},
    ]
  },

  {
    alias: 'widget.creditScore',
    type: 'boxSelect',
    fields: ['creditScore'],
    options: [
      {label: "499 or below", "value": "499", "range": {min: 100, max: 499}},
      {label: "500 - 599", "value": "599", "range": {min: 500, max: 599}},
      {label: "600 - 649", "value": "649", "range": {min: 600, max: 649}},
      {label: "650 - 679", "value": "679", "range": {min: 650, max: 679}},
      {label: "680 - 719", "value": "719", "range": {min: 680, max: 719}},
      {label: "720 or above", "value": "850", "range": {min: 720, max: 990}}
    ]
  },

  {
    alias: "widget.loanPurpose",
    type: 'multiBoxSelect',
    name: "What purpose would your loan serve? Select all that apply",
    fields: [
      'loanPurpose'
    ],
  },

  {
    alias: "widget.fundAspect",
    type: 'boxSelect',
    name: "Which is most important to you?",
    fields: [
      'fundAspect'
    ]
  },

  {
    alias: 'widget.about_your_business',
    type: 'multiBoxSelect',
    name: "Select all that apply.",
    fields: [
      { alias: 'bankruptcy', name: 'Have a prior bankruptcy', icon: '/images/desaturating-icons/icon-bankruptcy.png' },
      { alias: 'nonprofit', name: 'Operate as a non-profit', icon: '/images/desaturating-icons/icon-non-profit.png' },
      { alias: 'hasInvoices', name: 'Invoice customers', icon: '/images/desaturating-icons/icon-invoice.png' },
      { alias: 'franchise', name: 'Operate as a franchise', icon: '/images/desaturating-icons/icon-franchise.png' },
    ],
    mustAllowNull: true,
    auxiliaryButton: {
      label: 'None apply',
      click: 'none-apply'
    }
  },
  {
    alias: 'widget.business_start_date',
    type: 'date-month-year',
    fields: [
      'business_start_date'
    ],
    auxiliaryButton: {
      label: 'I haven\'t started yet',
      click: 'date-now'
    }
  },

  // ERC qualifications
  {
    alias: 'widget.has_w2_employees',
    fields: [ 'has_w2_employees' ],
    name: 'Did you employ W-2 employees in 2020 or 2021?',
  },
  {
    alias: 'widget.impacted_by_govt_order',
    fields: [ 'impacted_by_govt_order' ],
    name: "Was your business revenue impacted by a government-mandated slowdown or shutdown in 2020 or 2021, or by a supplier or partner's shutdown?",
  },
  {
    alias: 'widget.revenue_decreased_2020_2021',
    fields: [ 'revenue_decreased_2020_2021' ],
    name: 'Did your business experience a year-over-year revenue decrease during any quarter of 2020 or 2021?',
  },
  {
    alias: 'widget.operation_start_date',
    fields: [ 'operation_start_date' ],
    name: 'When did you start your business?',
  },
  {
    alias: 'widget.operation_start_date',
    fields: [ 'operation_start_date' ],
    name: 'When did you start your business?',
  },
  {
    alias: 'widget.average_employees_2020',
    fields: [ 'average_employees_2020' ],
    name: 'How many W-2 employees did you employ on average in 2020?',
  },
  {
    alias: 'widget.average_employees_2021',
    fields: [ 'average_employees_2021' ],
    name: 'How many W-2 employees did you employ on average in 2021?',
  },

  // ERC Fields for business info mailing address
  {
    alias: 'mailingAddress',
    fields: [
      'borrowerMailingStreet',
      'borrowerMailingCity',
      'borrowerMailingState',
      'borrowerMailingZip'
    ],
    type: 'address',
    dependsOn: 'separate_mailing_address',
    dependsExpression: '1'
  },
  {
    alias: 'widget.businessWebsite',
    fields: [
      'businessWebsite'
    ],
    name: 'Website (optional)',
    mustAllowNull: '1'
  },
  {
    alias: 'widget.federalstate_tax_id',
    fields: ['federalstate_tax_id'],
    name: 'Federal/State Tax ID (optional)',
    type: 'text',
    mustAllowNull: '1',
  },

  // ERC PEO info widgets
  {
    alias: 'widget.peoPhone',
    fields: ['peoPhone'],
    type: 'text',
  },
  {
    alias: 'widget.peoEmail',
    fields: ['peoEmail'],
    type: 'email',
  },

  // ERC Fields for Governance Order Pages
  {
    alias: 'widget.gov_order_time_frame',
    fields: [
      'gov_order_time_frame'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.prevented_customer_access',
    fields: [
      'prevented_customer_access'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.reduction_in_customers_served',
    fields: [
      'reduction_in_customers_served'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.reduction_in_contracts',
    fields: [
      'reduction_in_contracts'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.projects_affected',
    fields: [
      'projects_affected'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.production_declined',
    fields: [
      'production_declined'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.sales_reduced',
    fields: [
      'sales_reduced'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.reduced_hours',
    fields: [
      'reduced_hours'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.staggered_shifts',
    fields: [
      'staggered_shifts'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.workspace_modifications',
    fields: [
      'workspace_modifications'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.capacity_limitation',
    fields: [
      'capacity_limitation'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.in-person_meetings_affected',
    fields: [
      'in-person_meetings_affected'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },
  {
    alias: 'widget.suppliers_shutdown',
    fields: [
      'suppliers_shutdown'
    ],
    dependsOn: 'completely_shut_down|completely_shut_down,mods_on_reopen',
    dependsExpression: '{"completely_shut_down": ["0"], "completely_shut_down,mods_on_reopen": ["1", "1"]}'
  },

  {
    alias: 'widget.customer_visit_affected_period',
    fields: ['customer_visit_affected_period'],
    dependsOn: 'widget.prevented_customer_access',
    dependsExpression: '1'
  },
  {
    alias: 'widget.customer_visits_comparable_period',
    fields: ['customer_visits_comparable_period'],
    dependsOn: 'widget.prevented_customer_access',
    dependsExpression: '1'
  },
  {
    alias: 'widget.customer_visits_explanation',
    fields: ['customer_visits_explanation'],
    dependsOn: 'widget.prevented_customer_access',
    dependsExpression: '1'
  },

  {
    alias: 'widget.customers_served_affected_period',
    fields: ['customers_served_affected_period'],
    dependsOn: 'widget.reduction_in_customers_served',
    dependsExpression: '1'
  },
  {
    alias: 'widget.customers_served_comparable_period',
    fields: ['customers_served_comparable_period'],
    dependsOn: 'widget.reduction_in_customers_served',
    dependsExpression: '1'
  },
  {
    alias: 'widget.customers_served_explanation',
    fields: ['customers_served_explanation'],
    dependsOn: 'widget.reduction_in_customers_served',
    dependsExpression: '1'
  },

  {
    alias: 'widget.contracts_affected_period',
    fields: ['contracts_affected_period'],
    dependsOn: 'widget.reduction_in_contracts',
    dependsExpression: '1'
  },
  {
    alias: 'widget.contracts_comparable_period_',
    fields: ['contracts_comparable_period_'],
    dependsOn: 'widget.reduction_in_contracts',
    dependsExpression: '1'
  },
  {
    alias: 'widget.contracts_explanation',
    fields: ['contracts_explanation'],
    dependsOn: 'widget.reduction_in_contracts',
    dependsExpression: '1'
  },

  {
    alias: 'widget.projects_affected_period',
    fields: ['projects_affected_period'],
    dependsOn: 'widget.projects_affected',
    dependsExpression: '1'
  },
  {
    alias: 'widget.projects_comparable_period',
    fields: ['projects_comparable_period'],
    dependsOn: 'widget.projects_affected',
    dependsExpression: '1'
  },
  {
    alias: 'widget.projects_affected_explanation',
    fields: ['projects_affected_explanation'],
    dependsOn: 'widget.projects_affected',
    dependsExpression: '1'
  },

  {
    alias: 'widget.production_affected_period',
    fields: ['production_affected_period'],
    dependsOn: 'widget.production_declined',
    dependsExpression: '1'
  },
  {
    alias: 'widget.production_comparable_period',
    fields: ['production_comparable_period'],
    dependsOn: 'widget.production_declined',
    dependsExpression: '1'
  },
  {
    alias: 'widget.production_explanation',
    fields: ['production_explanation'],
    dependsOn: 'widget.production_declined',
    dependsExpression: '1'
  },

  {
    alias: 'widget.sales_reduced_affected_period',
    fields: ['sales_reduced_affected_period'],
    dependsOn: 'widget.sales_reduced',
    dependsExpression: '1'
  },
  {
    alias: 'widget.sales_reduced_comparable_period',
    fields: ['sales_reduced_comparable_period'],
    dependsOn: 'widget.sales_reduced',
    dependsExpression: '1'
  },
  {
    alias: 'widget.sales_reduced_explanation',
    fields: ['sales_reduced_explanation'],
    dependsOn: 'widget.sales_reduced',
    dependsExpression: '1'
  },

  {
    alias: 'widget.operation_hours_affected_period',
    fields: ['operation_hours_affected_period'],
    dependsOn: 'widget.reduced_hours',
    dependsExpression: '1'
  },
  {
    alias: 'widget.operation_hours_comparable_period',
    fields: ['operation_hours_comparable_period'],
    dependsOn: 'widget.reduced_hours',
    dependsExpression: '1'
  },
  {
    alias: 'widget.reduced_hours_explanation',
    fields: ['reduced_hours_explanation'],
    dependsOn: 'widget.reduced_hours',
    dependsExpression: '1'
  },

  {
    alias: 'widget.staggered_shifts_description',
    fields: ['staggered_shifts_description'],
    dependsOn: 'widget.staggered_shifts',
    dependsExpression: '1'
  },
  {
    alias: 'widget.staggered_shifts_explanation',
    fields: ['staggered_shifts_explanation'],
    dependsOn: 'widget.staggered_shifts',
    dependsExpression: '1'
  },

  {
    alias: 'widget.workspace_modifications_description',
    fields: ['workspace_modifications_description'],
    dependsOn: 'widget.workspace_modifications',
    dependsExpression: '1'
  },

  {
    alias: 'widget.capacity_affected_period',
    fields: ['capacity_affected_period'],
    dependsOn: 'widget.capacity_limitation',
    dependsExpression: '1'
  },
  {
    alias: 'widget.capacity_comparable_period',
    fields: ['capacity_comparable_period'],
    dependsOn: 'widget.capacity_limitation',
    dependsExpression: '1'
  },
  {
    alias: 'widget.capacity_limitation_explanation',
    fields: ['capacity_limitation_explanation'],
    dependsOn: 'widget.capacity_limitation',
    dependsExpression: '1'
  },

  {
    alias: 'widget.meetings_affected_description',
    fields: ['meetings_affected_description'],
    dependsOn: 'widget.in-person_meetings_affected',
    dependsExpression: '1'
  },
  {
    alias: 'widget.meeting_affected_explanation',
    fields: ['meeting_affected_explanation'],
    dependsOn: 'widget.in-person_meetings_affected',
    dependsExpression: '1'
  },

  {
    alias: 'widget.supplier_details',
    fields: ['supplier_details'],
    dependsOn: 'widget.suppliers_shutdown',
    dependsExpression: '1'
  },
  {
    alias: 'widget.supplier_shutdown_timeframe',
    fields: ['supplier_shutdown_timeframe'],
    dependsOn: 'widget.suppliers_shutdown',
    dependsExpression: '1'
  },
  // End ERC Governance Order Fields

  // SBA Fields
  {
    alias: 'widget.currentYearBusinessTaxReturnSubmitted',
    fields: ['currentYearBusinessTaxReturnSubmitted'],
    name: 'Have you filed a business tax return for ' + (currentYear - 1),
  },
  {
    alias: 'widget.currentYearPersonalTaxReturnSubmitted',
    fields: ['currentYearPersonalTaxReturnSubmitted'],
    name: 'Have you filed a personal tax return for ' + (currentYear - 1),
  }
]
